import Header from "./components/Header/Header"
import Lesson from "./pages/Lesson"
import "./App.css"
function App() {
  return (
    <div>
      <Header/>
      <Lesson/>
    </div>
  )
}

export default App
